<template>
<v-container
  fluid
>
  <v-layout>
    <v-flex>

      <v-tabs
        v-model="tab"
      >
        <v-tab
          v-for="item in items"
          :key="item.tab"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in items"
          :key="item.tab"
        >
          <CardsLine
            :header="item.tab"
            :data="getContent(item.content)"
          />
        </v-tab-item>
      </v-tabs-items>

    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import CardsLine from '../components/CardsLine'
import { mapState, mapGetters } from 'vuex'


export default {
  name: 'Dashboard',

  components: {
    CardsLine,
  },

  computed: {
    ...mapState(['loveit', 'feed',]),
    ...mapGetters(['isSeen', 'isLoved', 'isNotSeen']),
  },

  methods: {
    getContent(content) {
      // console.log(content);
      if (content === 'recent') {
        return this.isNotSeen;
      } else if (content === 'seen') {
        return this.isSeen;
      } else if (content === 'loveit') {
        return this.isLoved;
      } else {
        return this.feed;
      }
    },
  },

  data: () => ({
    tab: null,
    items: [
      { tab: 'Inbox', content: 'recent' },
      { tab: 'Favs', content: 'loveit' },
      { tab: 'Archive', content: 'seen' },
      { tab: 'Feeds', content: 'feed' },
      { tab: 'Tabs', content: 'feed' },
    ]
  })
};
</script>


<style scoped>
</style>
